const styles = (theme) => ({
  description: {
    margin: theme.spacing(0, 0, 3.75),
  },
  confirmationDescription: {
    margin: theme.spacing(0, 0, 1.5),
  },
  infoBlock: {
    padding: theme.spacing(2.5),
  },
  borderBottom: {
    borderBottom: `1px solid ${theme.color.grey_d3}`,
  },
  orderDeliveryInfo: {
    padding: theme.spacing(0, 0, 4),
  },
  mainInfoHeader: {
    padding: theme.spacing(1, 0, 1),
  },
  productInfoContainer: {
    padding: theme.spacing(1.25, 2.5),
  },
  email: {
    color: theme.color.teal,
  },
});

export default styles;
